module.exports = __webpack_public_path__ + "img/light-blue-arrow-left.cbb48311.svg";